/**
 * Our VINTAGE smiles
 */

// general smiles
import iconArrow from './icon_arrow.gif';
import iconCool from './icon_cool.gif';
import iconCry from './icon_cry.gif';
import iconBigGrin from './icon_e_biggrin.gif';
import iconConfused from './icon_e_confused.gif';
import iconEek from './icon_eek.gif';
import iconGeek from './icon_e_geek.gif';
import iconSad from './icon_e_sad.gif';
import iconSmile from './icon_e_smile.gif';
import iconSurprised from './icon_e_surprised.gif';
import iconUgeek from './icon_e_ugeek.gif';
import iconEvil from './icon_evil.gif';
import iconWink from './icon_e_wink.gif';
import iconExclaim from './icon_exclaim.gif';
import iconIdea from './icon_idea.gif';
import iconLol from './icon_lol.gif';
import iconMad from './icon_mad.gif';
import iconMrGreen from './icon_mrgreen.gif';
import iconNeutral from './icon_neutral.gif';
import iconQuestion from './icon_question.gif';
import iconRazz from './icon_razz.gif';
import iconRedFace from './icon_redface.gif';
import iconRolleyEyes from './icon_rolleyes.gif';
import iconTwisted from './icon_twisted.gif';


// domik smiles
import ten from './domik/10.gif';
import eleven from './domik/11.gif';
import twelve from './domik/12.gif';
import oneThreeFour from './domik/134.gif';
import thirteen from './domik/13.gif';
import oneFiveEight from './domik/158.gif';
import fifteen from './domik/15.gif';
import sixteen from './domik/16.gif';
import seventeen from './domik/17.gif';
import eighteen from './domik/18.gif';
import one from './domik/1.gif';
import twoOne from './domik/21.gif';
import twenty from './domik/20.gif';
import twoFive from './domik/25.gif';
import twoSeven from './domik/27.gif';
import twoNine from './domik/29.gif';
import thirty from './domik/30.gif';
import threeOne from './domik/31.gif';
import threeTwo from './domik/32.gif';
import threeFour from './domik/34.gif';
import threeSix from './domik/36.gif';
import threeSeven from './domik/37.gif';
import threeEight from './domik/38.gif';
import threeNine from './domik/39.gif';
import fourty from './domik/40.gif';
import fourOne from './domik/41.gif';
import fourFive from './domik/45.gif';
import fourSeven from './domik/47.gif';
import fourNine from './domik/49.gif';
import four from './domik/4.gif';
import fifty from './domik/50.gif';
import fiveOne from './domik/51.gif';
import fiveThree from './domik/53.gif';
import fiveSix from './domik/56.gif';
import fiveSeven from './domik/57.gif';
import fiveEight from './domik/58.gif';
import fiveNine from './domik/59.gif';
import five from './domik/5.gif';
import sixTwo from './domik/62.gif';
import sixThree from './domik/63.gif';
import sixSix from './domik/66.gif';
import sixSeven from './domik/67.gif';
import six from './domik/6.gif';
import sevenOne from './domik/71.gif';
import sevenTwo from './domik/72.gif';
import sevenThree from './domik/73.gif';
import sevenFour from './domik/74.gif';
import sevenSix from './domik/76.gif';
import sevenSeven from './domik/77.gif';
import seven from './domik/7.gif';
import eightThree from './domik/83.gif';
import eightFour from './domik/84.gif';
import eightFive from './domik/85.gif';
import eightSix from './domik/86.gif';
import eightSeven from './domik/87.gif';
import eightEight from './domik/88.gif';
import eightNine from './domik/89.gif';
import eight from './domik/8.gif';
import ninety from './domik/90.gif';
import nineOne from './domik/91.gif';
import nineTwo from './domik/92.gif';
import nineThree from './domik/93.gif';
import nineFour from './domik/94.gif';
import nineFive from './domik/95.gif';
import nineSix from './domik/96.gif';
import nineSeven from './domik/97.gif';
import nineEight from './domik/98.gif';
import nineNine from './domik/99.gif';
import nine from './domik/9.gif';

import aaa from './domik/aaa.gif';
import adr from './domik/adr.gif';
import alc from './domik/alc.gif';
import apl from './domik/apl.gif';
import att from './domik/att.gif';
import au from './domik/au.gif';

import bam from './domik/bam.gif';
import bath from './domik/bath.gif';
import bee from './domik/bee.gif';
import biggrin from './domik/biggrin.gif';
import bis from './domik/bis.gif';
import blah from './domik/blah.gif';
import bl from './domik/bl.gif';
import blink2 from './domik/blink2.gif';
import boot from './domik/boot.gif';
import bot from './domik/bot.gif';
import bow from './domik/bow.gif';
import box2 from './domik/box2.gif';
import box from './domik/box.gif';
import brsh from './domik/brsh.gif';
import buben from './domik/buben.gif';
import bubu from './domik/bubu.gif';
import bud from './domik/bud.gif';
import budo from './domik/budo.gif';
import bye from './domik/bye.gif';

import clap from './domik/clap.gif';
import confused from './domik/confused.gif';
import cool from './domik/cool.gif';
import cowb from './domik/cowb.gif';
import crazy from './domik/crazy.gif';
import croc from './domik/croc.gif';
import cry2 from './domik/cry2.gif';

import dai from './domik/dai.gif';
import dan from './domik/dan.gif';
import dark from './domik/dark.gif';
import datel from './domik/datel.gif';
import daz from './domik/daz.gif';
import ded from './domik/ded.gif';
import dog from './domik/dog.gif';
import dozor from './domik/dozor.gif';
import drink from './domik/drink.gif';
import drug from './domik/drug.gif';
import drv from './domik/drv.gif';
import duel from './domik/duel.gif';

import eek from './domik/eek.gif';
import egg from './domik/egg.gif';
import emosk from './domik/emosk.gif';
import end from './domik/end.gif';

import faceoff from './domik/faceoff.gif';
import fart from './domik/fart.gif';
import fire from './domik/fire.gif';
import fkr from './domik/fkr.gif';
import fly2 from './domik/fly2.gif';
import fly from './domik/fly.gif';
import fol from './domik/fol.gif';
import frfr from './domik/frfr.gif';
import frown from './domik/frown.gif';

import galstuk from './domik/galstuk.gif';
import gaz from './domik/gaz.gif';
import girl from './domik/girl.gif';
import golubi from './domik/golubi.gif';
import goodorbad from './domik/goodorbad.gif';
import goss from './domik/goss.gif';
import gost from './domik/gost.gif';
import gotmail from './domik/gotmail.gif';
import gun from './domik/gun.gif';
import gy from './domik/gy.gif';

import hah from './domik/hah.gif';
import hamster from './domik/hamster.gif';
import hb from './domik/hb.gif';
import hit from './domik/hit.gif';
import hlp from './domik/hlp.gif';
import hmm from './domik/hmm.gif';
import hook1 from './domik/hook1.gif';
import hook2 from './domik/hook2.gif';
import hul from './domik/hul.gif';

import idiots from './domik/idiots.gif';
import ih from './domik/ih.gif';
import inc from './domik/inc.gif';
import index from './domik/index.gif';
import invalid from './domik/invalid.gif';
import ipoteka from './domik/ipoteka.gif';
import iq from './domik/iq.gif';
import ivn from './domik/ivn.gif';
import jok from './domik/jok.gif';

import kap from './domik/kap.gif';
import kar from './domik/kar.gif';
import kass from './domik/kass.gif';
import king from './domik/king.gif';
import kngt from './domik/kngt.gif';
import kon from './domik/kon.gif';
import kos from './domik/kos.gif';
import kto from './domik/kto.gif';
import ktozdes from './domik/ktozdes.gif';
import kuku from './domik/kuku.gif';
import kuli from './domik/kuli.gif';
import kult from './domik/kult.gif';

import lam from './domik/lam.gif';
import leb from './domik/leb.gif';
import lu from './domik/lu.gif';

import mad3 from './domik/mad3.gif';
import mad from './domik/mad.gif';
import ma from './domik/ma.gif';
import mail from './domik/mail.gif';
import man from './domik/man.gif';
import maniac from './domik/maniac.gif';
import mar from './domik/mar.gif';
import mat from './domik/mat.gif';
import minzdr from './domik/minzdr.gif';
import mob from './domik/mob.gif';
import mog from './domik/mog.gif';
import mpr from './domik/mpr.gif';
import much from './domik/much.gif';

import n1 from './domik/n1.gif';
import n2 from './domik/n2.gif';
import n3 from './domik/n3.gif';
import n4 from './domik/n4.gif';
import nafig from './domik/nafig.gif';
import nap from './domik/nap.gif';
import newy from './domik/newy.gif';
import no from './domik/no.gif';
import nomail from './domik/nomail.gif';
import notsmile from './domik/notsmile.gif';
import nud from './domik/nud.gif';
import nunu from './domik/nunu.gif';

import obm from './domik/obm.gif';
import oh from './domik/oh.gif';
import olen from './domik/olen.gif';
import ora from './domik/ora.gif';
import otk from './domik/otk.gif';
import out from './domik/out.gif';

import pauk from './domik/pauk.gif';
import pila from './domik/pila.gif';
import popc1 from './domik/popc1.gif';
import pop from './domik/pop.gif';
import pot from './domik/pot.gif';
import poz from './domik/poz.gif';
import pray from './domik/pray.gif';
import pri from './domik/pri.gif';
import psih from './domik/psih.gif';
import puzir from './domik/puzir.gif';
import pya from './domik/pya.gif';

import redface from './domik/redface.gif';
import repa from './domik/repa.gif';
import rev from './domik/rev.gif';
import roga from './domik/roga.gif';
import rog from './domik/rog.gif';
import rolleyes from './domik/rolleyes.gif';
import rom2 from './domik/rom2.gif';
import rom from './domik/rom.gif';

import sad from './domik/sad.gif';
import ser from './domik/ser.gif';
import sex from './domik/sex.gif';
import sharm from './domik/sharm.gif';
import shuffle from './domik/shuffle.gif';
import shv from './domik/shv.gif';
import shy2 from './domik/shy2.gif';
import shy from './domik/shy.gif';
import sla from './domik/sla.gif';
import smile_classic from './domik/smile_classic.gif';
import smile from './domik/smile.gif';
import sml from './domik/sml.gif';
import sndmail from './domik/sndmail.gif';
import sneaking from './domik/sneaking.gif';
import stp from './domik/stp.gif';
import str from './domik/str.gif';
import sumo from './domik/sumo.gif';
import superSmile from './domik/super.gif';
import susel from './domik/susel.gif';
import sweet from './domik/sweet.gif';

import tel from './domik/tel.gif';
import thk from './domik/thk.gif';
import titanic from './domik/titanic.gif';
import tnp from './domik/tnp.gif';
import tongue from './domik/tongue.gif';
import tooth from './domik/tooth.gif';
import trud from './domik/trud.gif';
import tualet from './domik/tualet.gif';

import umn from './domik/umn.gif';
import umnik from './domik/umnik.gif';
import unknw from './domik/unknw.gif';
import upl from './domik/upl.gif';
import ura1 from './domik/ura1.gif';

import val from './domik/val.gif';
import velo from './domik/velo.gif';
import ven from './domik/ven.gif';
import veslo from './domik/veslo.gif';
import vis from './domik/vis.gif';

import wan from './domik/wan.gif';
import wc from './domik/wc.gif';
import web from './domik/web.gif';
import winky from './domik/winky.gif';
import wow from './domik/wow.gif';

import xlb from './domik/xlb.gif';
import yaya from './domik/yaya.gif';
import yes from './domik/yes.gif';
import yogi from './domik/yogi.gif';

export default {
  // - 1 -
  smile_classic,
  yes,
  drink,
  nine,
  winky,
  sevenThree,
  cool,
  n1,
  tongue,
  bye,
  bow,
  fiveEight,
  n2,
  twenty,
  blink2,
  no,
  shuffle,
  sevenOne,
  n4,
  confused,
  eleven,
  faceoff,
  umnik,
  ded,
  pray,
  notsmile,
  five,
  n3,
  wow,
  eek,
  eightThree,
  oh,
  four,
  fiveSeven,
  fourOne,
  nineNine,
  blah,
  twoOne,
  ura1,
  superSmile,
  poz,
  bis,
  hb,
  leb,
  clap,
  fifteen,
  alc,
  buben,
  hamster,
  puzir,
  // - 2 -
  olen,
  yaya,
  kap,
  att,
  ih,
  gy,
  hah,
  jok,
  popc1,
  bubu,
  rog,
  nud,
  nunu,
  hul,
  cowb,
  bud,
  gun,
  susel,
  kon,
  budo,
  duel,
  box2,
  kar,
  iq,
  box,
  bam,
  invalid,
  pauk,
  fkr,
  maniac,
  gost,
  dozor,
  au,
  vis,
  fourFive,
  daz,
  goodorbad,
  inc,
  adr,
  pop,
  minzdr,
  mog,
  dark,
  kass,
  croc,
  ivn,
  fly2,
  kos,
  fly,
  fol,
  // - 3 -
  dog,
  ser,
  rom2,
  rom,
  dan,
  hit,
  stp,
  wan,
  lu,
  sex,
  mar,
  xlb,
  gaz,
  web,
  ma,
  dai,
  twoNine,
  kuli,
  velo,
  sevenTwo,
  pila,
  datel,
  emosk,
  umn,
  pya,
  mob,
  brsh,
  tooth,
  hlp,
  drug,
  drv,
  val,
  index,
  fiveThree,
  lam,
  nomail,
  gotmail,
  mail,
  sndmail,
  hook1,
  hook2,
  apl,
  ipoteka,
  egg,
  titanic,
  bot,
  repa,
  idiots,
  goss,
  fart,
  // - 4 -
  king,
  galstuk,
  rev,
  thirty,
  girl,
  obm,
  cry2,
  sweet,
  thk,
  kult,
  much,
  mpr,
  nineSeven,
  frown,
  sad,
  nineEight,
  seven,
  yogi,
  hmm,
  nap,
  kngt,
  mat,
  sharm,
  newy,
  eightSix,
  fire,
  sml,
  frfr,
  sneaking,
  boot,
  shv,
  end,
  kuku,
  kto,
  pri,
  aaa,
  roga,
  out,
  bath,
  tualet,
  wc,
  ora,
  trud,
  tnp,
  bee,
  golubi,
  veslo,
  ven,
  otk,
  upl,
  // - 5 -
  sixTwo,
  eightNine,
  sevenSeven,
  twoSeven,
  sixSix,
  threeFour,
  eightSeven,
  sevenSix,
  threeTwo,
  ninety,
  nineOne,
  tel,
  // - other -

  // general smiles
  iconArrow,
  iconCool,
  iconCry,
  iconBigGrin,
  iconConfused,
  iconEek,
  iconGeek,
  iconSad,
  iconSmile,
  iconSurprised,
  iconUgeek,
  iconEvil,
  iconWink,
  iconExclaim,
  iconIdea,
  iconLol,
  iconMad,
  iconMrGreen,
  iconNeutral,
  iconQuestion,
  iconRazz,
  iconRedFace,
  iconRolleyEyes,
  iconTwisted,
  // domik smiles
  ten,
  twelve,
  oneThreeFour,
  thirteen,
  oneFiveEight,
  sixteen,
  seventeen,
  eighteen,
  one,
  twoFive,
  threeOne,
  threeSix,
  threeSeven,
  threeEight,
  threeNine,
  fourty,
  fourSeven,
  fourNine,
  fifty,
  fiveOne,
  fiveSix,
  fiveNine,
  sixThree,
  sixSeven,
  six,
  sevenFour,
  eightFour,
  eightFive,
  eightEight,
  eight,
  nineTwo,
  nineThree,
  nineFour,
  nineFive,
  nineSix,
  biggrin,
  bl,
  crazy,
  ktozdes,
  mad3,
  mad,
  man,
  nafig,
  pot,
  psih,
  redface,
  rolleyes,
  shy2,
  shy,
  sla,
  smile,
  str,
  sumo,
  unknw
};
